import {clsx} from 'external/clsx'
import {isUUID} from 'external/lodash'
import {
    Link,
    useLocation,
    useParams,
    useMemo
} from 'external/react'
import Icon from 'external/fortawesome'

import usePayment from 'context/payment-context/hook'

//import { usePayment } from 'context/PaymentContext'

export default function ShoppingCart (props) {
    const {className} = props
    const {packageStatus, packageItem} = usePayment()
    const {offerId} = useParams()
    const {pathname} = useLocation()

    const hidden = useMemo(() => {
        if (packageStatus.coursesCount === 0) return true
		if (packageStatus.notFound) return true
        if (pathname === '/summary') return true
        if (isUUID(offerId)) return true
        return false
    }, [pathname, packageStatus, offerId])
    
    const to = useMemo(() => {
        return packageStatus.missingCourses && packageItem
            ? `/offers/${packageItem.offerId}`
            : '/summary'
    }, [packageItem, packageStatus])

    return (
        <li className={clsx(className, {'d-none': hidden})}>
            <Link to={to} className='cart'>
                <Icon name="faShoppingCart" style={{ width: '1.4rem', height: '1.4rem' }} />
                <span data-action='cart-can' className='badge rounded-circle' />
            </Link>
        </li>
    )
}